import React, { ReactElement } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@ygtechnologies/bygr-frontend-component-library';
import { Trans } from '@lingui/react/macro';
import { Button } from '@/components/Buttons';

interface ErrorDialogProps {
    title: ReactElement;
    body: ReactElement;
    show: boolean;
    onClose(): void;
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({ title, body, show, onClose }) => {
    return (
        <Modal isOpen={show} toggle={onClose}>
            <ModalHeader>{title || <Trans>Error!</Trans>}</ModalHeader>
            <ModalBody>{body || <Trans>An unexpected error has occurred.</Trans>}</ModalBody>
            <ModalFooter>
                <Button color="tertiary" onClick={onClose}>
                    <Trans>Ok</Trans>
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ErrorDialog;